// Default Habits
export const defaultHabits = ['recycling', 'composting', 'energyUsage', 'waterConservation', 'reusableBags'];

// Habit Descriptions
export const habitDescriptions = {
    recycling: 'Recycling helps reduce waste by converting materials into reusable objects.',
    composting: 'Composting turns organic waste into valuable fertilizer for your garden.',
    energyUsage: 'Energy conservation reduces your carbon footprint and saves on utility bills.',
    waterConservation: 'Saving water helps preserve our planet`s most vital resource.',
    reusableBags: 'Using reusable bags reduces plastic waste and pollution.',
};

// Habit Units
export const habitUnits = {
    recycling: 'kg',
    composting: 'kg',
    energyUsage: 'kWh',
    waterConservation: 'liters',
    reusableBags: 'bags',
};